import { CardBody as ChakraCardBody } from '@chakra-ui/react';

export default function CardBody({ padding = null, children }) {
  return (
    <ChakraCardBody p={padding ? padding : '0'} flexGrow="grow">
      {children}
    </ChakraCardBody>
  );
}
